import React, { useContext, useState, memo, useCallback } from "react";
import CalendarLayout from "./CalenderLayout";
import "./WeekView.css";
import Modal from "../../../../components/controls/modal/Modal";
import ResourceDetailView from "./ResourceDetailView";
import { ResourcePlannerContext } from "../ResourcePlannerContext";

const WeekView = memo(({ formBody, dashboard }) => {
  const {
    useDetails,
    calendarHeader,
    calendarData,
    detail,
    setSelectedDays,
    setStartDate,
    setEndDate,
    setSelectedValue,
  } = useContext(ResourcePlannerContext);

  const [showDetailModal, setShowDetailModal] = useState(false);

  const handleCancel = useCallback(() => {
    setShowDetailModal(false);
    setSelectedDays([]);
    setStartDate(null);
    setEndDate(null);
    setSelectedValue(null);
  }, [setSelectedDays, setStartDate, setEndDate, setSelectedValue]);

  const handleClick = useCallback((value) => {
    setShowDetailModal(value);
  }, []);

  return (
    <React.Fragment>
      {showDetailModal && (
        <Modal
          title="Resource Details"
          handleCancel={handleCancel}
          handleSave={handleCancel}
          saveBtnLabel="Save"
          cancelBtnLabel="Cancel"
          isLoading={false}
          size="small"
          calendarModalWrap={true}
          body={
            <ResourceDetailView
              formBody={formBody}
              title={calendarHeader[detail.ind].name}
              label={calendarHeader[detail.ind].date}
              userDetails={useDetails[detail?.userIndex]}
              shift={{ ...detail.shift }}
            />
          }
        />
      )}
      <CalendarLayout
        dashboard={dashboard}
        userData={useDetails}
        calendarData={calendarData}
        headerDate={calendarHeader}
        handleClick={handleClick}
      />
    </React.Fragment>
  );
});

WeekView.displayName = 'WeekView';

export default WeekView;
